import './ClarifyModal.scss';
import { faSortAmountDown, faSortAmountUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Modal } from '../../../../../../design/modals/modal/S_Modal';
import { toLocaleDateTimeString } from '../../../../../helpers/date.helpers';
import { SortingDirection } from '../../../../../models/sortingDirection.model';
import { IClarification } from '../models/Clarifications.models';

interface IProps {
  showModal: boolean;
  sortDirection: SortingDirection;
  clarificationsList: IClarification[];
  onToggleChange: () => void;
  onSortDirectionChange: () => void;
}

export const ClarificationsListModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_Modal
      className='image-clarifications-list-modal'
      isOpen={props.showModal}
      toggle={props.onToggleChange}
      headerText={t('clarifications.list_modal.header')}
      buttons={
        <>
          <Button
            variant='outlined'
            onClick={props.onToggleChange}
          >
            {t('close')}
          </Button>
        </>
      }
    >
      <div>
        <div
          className='clarifications-sorting'
          onClick={props.onSortDirectionChange}
        >
          {props.sortDirection === SortingDirection.ASC && (
            <div>
              {t('clarifications.common.oldest')} <FontAwesomeIcon icon={faSortAmountUp} />
            </div>
          )}
          {props.sortDirection === SortingDirection.DESC && (
            <div>
              {t('clarifications.common.newest')} <FontAwesomeIcon icon={faSortAmountDown} />
            </div>
          )}
        </div>
      </div>
      {props.clarificationsList.map((clarification: IClarification, index: number) => {
        return (
          <div key={`image-clarification-${index}`}>
            <p className='clarification-item'>
              <span className='bold-text'>{clarification.askedBy}</span> {toLocaleDateTimeString(clarification.askedDate)}
              <br />
              <span className='bold-text'>{t('clarifications.common.question')}: </span>
              {clarification.question}
            </p>
            <p className='clarification-item'>
              <span className='bold-text'>{clarification.answeredBy}</span> {toLocaleDateTimeString(clarification.answeredDate)}
              <br />
              <span className='bold-text'>{t('clarifications.common.answer')}: </span>
              {clarification.answer}
            </p>
            {props.clarificationsList.length - 1 > index && <hr />}
          </div>
        );
      })}
    </S_Modal>
  );
});
